module.exports = __webpack_public_path__ + "static/index/img/baikal-115.5b73aea3.jpg";